// Moved to @livingsyncs/ui (frontend split epic, Phase 2 Task 2.2). Shim kept
// so nothing importing the old path breaks during the transition.
// Real function declarations, not reference copies — see hooks/useAuth.ts.
//
// Deep import, NOT the main barrel (`@livingsyncs/ui`) — fixed 2026-09-12,
// real bug found this session. This module is imported (transitively, via
// keychainTokenStore.ts) by capacitorBridge.ts, which is deliberately
// main.tsx's FIRST import. The main barrel (`src/index.ts`) re-exports
// `./lib/platform`, whose `desktop`/`isCapacitor` are plain top-level
// consts computed once, synchronously, reading `window.livingsyncs` the
// instant that module body runs. Importing the barrel here forced
// platform.ts to evaluate — capturing `desktop` as `undefined` — BEFORE
// capacitorBridge.ts ever reached its own installCapacitorBridge() call,
// which is what actually sets `window.livingsyncs`. `desktop` was
// permanently `undefined` for the life of the app, silently disabling
// every consumer gated on it (NativeSessionGuard's idle-lock listeners
// chief among them — confirmed live: a screen-lock/unlock cycle produced
// zero server-side trace across repeated tests). packages/ui/src/lib/sentry.ts
// itself only imports @sentry/react and a type from @livingsyncs/types —
// nothing that reaches platform.ts — so this deep import breaks the chain
// at its source instead of trying to defer it (a dynamic import here does
// NOT work: this exact file is ALSO statically imported directly by
// main.tsx for initSentry(), so Rollup folds both into the same chunk
// regardless — this repo's own "chunk-split guard" build plugin (SCRUM-110)
// exists specifically to hard-fail on that pattern, since a dynamic import
// of a dually-imported module can resolve to `undefined` at runtime).
// Same established pattern as DataTableShell/crossAppRedirect/sharedRoutes
// elsewhere in this codebase — see gotcha_packages_barrel_breaks_every_consumer_build.
import * as _sentryModule from "@livingsyncs/ui/src/lib/sentry";

export function scrubUrlQuery(url: unknown) {
  return _sentryModule.scrubUrlQuery(url);
}
export function isLiveEnvironment(environment: string) {
  return _sentryModule.isLiveEnvironment(environment);
}
export function initSentry() {
  return _sentryModule.initSentry();
}
export function setSentryAuthContext(
  ...args: Parameters<typeof _sentryModule.setSentryAuthContext>
) {
  return _sentryModule.setSentryAuthContext(...args);
}
export function clearSentryContext() {
  return _sentryModule.clearSentryContext();
}
export function captureException(
  ...args: Parameters<typeof _sentryModule.captureException>
) {
  return _sentryModule.captureException(...args);
}
export function captureMessage(
  ...args: Parameters<typeof _sentryModule.captureMessage>
) {
  return _sentryModule.captureMessage(...args);
}
